import { Component, Inject, OnDestroy, ChangeDetectionStrategy, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService,ConfirmedValidator } from './services/index'

import { UserSessionService } from './sevices/user-session.service'

import { User } from './models/index'
import { Error } from './models/index'
import { Router } from '@angular/router';
import { WhitelabelConfigStore } from './core/config/whitelabel-config.store';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnDestroy {
  title = 'operator-booking';
  loginForm: UntypedFormGroup;
  signupForm: UntypedFormGroup;
  resetForm: UntypedFormGroup;
  codeForm: UntypedFormGroup;
  passwordUpdateForm:  UntypedFormGroup;
  otpAuthForm: UntypedFormGroup;
  otpCodeForm: UntypedFormGroup;
  resMsg:any;
  res:any;
  resLogin:any;
  isLoggedIn:any;
  user:User;
  api_error:Error;
  successLogin:boolean=false;
  loadingStart:boolean = false;
  loadingSignup:boolean = false;
  loadingLogin:boolean = false;
  loginsubmitted=false;
  api_error_login:any;
  isHidden:boolean = true;
  is_api_error_login:boolean = false;
  authMode: 'phone' | 'email' = 'phone';
  authStep: 'identify' | 'sending' | 'verify' | 'verifying' | 'done' = 'identify';
  authIdentifier = '';
  authChannel: 'sms' | 'email' = 'sms';
  authError = '';
  authResendSeconds = 0;
  private authResendTimer: ReturnType<typeof setInterval> | null = null;

  submitted=false;
  success=false

  // reset password vars
  resetsubmitted:boolean = false;
  loadingReset:boolean = false;
  successReset:boolean = false;
  resetSuccessMsg:any;
  user_email_reset:string;
  resetErrMsg:string;
// submit reset code variables
  codeubmitted:boolean=false;
  loadingCode:boolean=false;
  successode:boolean = true;
  codeSuccessMsg:string;
  passToken:string;

  // update password variables
  updateSubmitted:boolean = false;
  loadingPasswordUpdate:boolean = false;
  loadingUpdatePassword:boolean = false;
  successPasswordUpdate:boolean = false;
  updatePassSuccessMsg: string;
  constructor( private _fb: UntypedFormBuilder,
    private sessionService:UserSessionService,
    private router:Router,
    private users:UserService,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    public configStore: WhitelabelConfigStore) {

    this.loginForm = _fb.group({
      email:['', [Validators.required,Validators.email]],
      password:['', Validators.required],
    });

    this.otpAuthForm = _fb.group({
      identifier: ['', Validators.required]
    });

    this.otpCodeForm = _fb.group({
      d0: [''], d1: [''], d2: [''], d3: [''], d4: [''], d5: ['']
    });

    this.signupForm = _fb.group({
      first_name:['', Validators.required],
      last_name:['', Validators.required],
      phone_number:['', [Validators.required,Validators.pattern('^(?:254|\\+254|0)(7|1)[0-9]{8}$')]],
      id_number:['',[ Validators.required,Validators.pattern('^[a-zA-Z0-9]*$'),Validators.minLength(7),Validators.maxLength(14)]],
      email:['', [Validators.required,Validators.email]],
      password:['', [Validators.required,Validators.minLength(6)]],
    });
    this.resetForm = _fb.group({
      email:['', [Validators.required,Validators.email]],
    });

    this.codeForm = _fb.group({
      code:['', Validators.required],
    });

    this.passwordUpdateForm = _fb.group({
      password:['', [Validators.required,Validators.minLength(8)]],
      confirmpassword:['', [Validators.required,Validators.minLength(8)]],
    },{ 
      validator: ConfirmedValidator('password', 'confirmpassword')
    });

  }

  readonly configState$ = this.configStore.state$;

  get config() {
    return this.configStore.snapshot.config;
  }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.isLoggedIn = localStorage.getItem('isLoggedInEasy');
    if(this.isLoggedIn ){
      this.user=new User().deserialize(JSON.parse(localStorage.getItem('userEasy')))
      // this.getUserProfile(this.user);
    }
  }

  get f() { return this.signupForm.controls; }

  ngOnDestroy(): void {
    this.stopAuthResendTimer();
  }

  setAuthMode(mode: 'phone' | 'email'): void {
    this.authMode = mode;
    this.authError = '';
    this.otpAuthForm.reset({ identifier: '' });
  }

  requestOtp(): void {
    const identifier = this.normalizedAuthIdentifier();
    if (!identifier) {
      this.authError = this.authMode === 'email'
        ? 'Enter a valid email address.'
        : 'Enter a valid Kenyan mobile number.';
      this.otpAuthForm.get('identifier')?.markAsTouched();
      return;
    }

    this.authError = '';
    this.authIdentifier = identifier;
    this.authChannel = this.authMode === 'email' ? 'email' : 'sms';
    this.authStep = 'sending';
    this.users.login(this.otpPayload(true)).subscribe({
      next: () => {
        this.authStep = 'verify';
        this.otpCodeForm.reset();
        this.startAuthResendTimer();
        setTimeout(() => this.focusOtpDigit(0));
      },
      error: error => {
        this.authStep = 'identify';
        this.authError = this.authApiError(error, 'We could not send the code. Please try again.');
      }
    });
  }

  verifyOtp(): void {
    const code = this.otpCodeValue();
    if (code.length !== 6) {
      this.authError = 'Enter the complete 6-digit code.';
      return;
    }

    this.authError = '';
    this.authStep = 'verifying';
    this.users.login({ ...this.otpPayload(false), otp_code: code }).subscribe({
      next: response => {
        this.authStep = 'done';
        this.resMsg = response;
        if (this.resMsg?.data) {
          localStorage.setItem('isLoggedInEasy', 'true');
          localStorage.setItem('userEasy', JSON.stringify(this.resMsg.data));
          sessionStorage.setItem('userEasy', JSON.stringify(this.resMsg.data));
          this.user = new User().deserialize(this.resMsg.data);
          this.isLoggedIn = true;
          this.sessionService.changeMessage(this.resMsg.data);
          this.users.changeSuccessMessage(this.resMsg.data);
        }
        this.stopAuthResendTimer();
        setTimeout(() => {
          document.getElementById('closeLogin')?.click();
          this.resetOtpAuth();
          this.router.navigate(['/my-booking']);
        }, 900);
      },
      error: error => {
        this.authStep = 'verify';
        this.authError = this.authApiError(error, 'That code is incorrect or expired. Try again.');
      }
    });
  }

  resendOtp(): void {
    if (this.authResendSeconds > 0) {
      return;
    }
    this.authStep = 'sending';
    this.users.login(this.otpPayload(true)).subscribe({
      next: () => {
        this.authStep = 'verify';
        this.otpCodeForm.reset();
        this.authError = '';
        this.startAuthResendTimer();
        setTimeout(() => this.focusOtpDigit(0));
      },
      error: error => {
        this.authStep = 'verify';
        this.authError = this.authApiError(error, 'We could not resend the code. Please try again.');
      }
    });
  }

  editAuthIdentifier(): void {
    this.stopAuthResendTimer();
    this.authStep = 'identify';
    this.authError = '';
    this.otpCodeForm.reset();
  }

  resetOtpAuth(): void {
    this.stopAuthResendTimer();
    this.authMode = 'phone';
    this.authStep = 'identify';
    this.authIdentifier = '';
    this.authChannel = 'sms';
    this.authError = '';
    this.authResendSeconds = 0;
    this.otpAuthForm.reset({ identifier: '' });
    this.otpCodeForm.reset();
  }

  onOtpInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    const values = digits.slice(0, 6 - index).split('');
    values.forEach((digit, offset) => {
      this.otpCodeForm.get(`d${index + offset}`)?.setValue(digit, { emitEvent: false });
    });
    input.value = values[0] || '';
    this.authError = '';
    if (values.length) {
      this.focusOtpDigit(Math.min(5, index + values.length));
    }
  }

  onOtpKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace' && !this.otpCodeForm.get(`d${index}`)?.value && index > 0) {
      this.focusOtpDigit(index - 1);
    }
  }

  get maskedAuthIdentifier(): string {
    return this.authIdentifier;
  }

  private normalizedAuthIdentifier(): string | null {
    const value = String(this.otpAuthForm.get('identifier')?.value || '').trim();
    if (this.authMode === 'email') {
      return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value) ? value : null;
    }
    const digits = value.replace(/[\s-]/g, '');
    if (!/^(?:\+?254|0)?[17]\d{8}$/.test(digits)) {
      return null;
    }
    if (digits.startsWith('+254')) {
      return digits;
    }
    if (digits.startsWith('254')) {
      return `+${digits}`;
    }
    if (digits.startsWith('0')) {
      return `+254${digits.slice(1)}`;
    }
    return `+254${digits}`;
  }

  private otpPayload(request: boolean): Record<string, unknown> {
    return {
      ...(this.authChannel === 'email'
        ? { email: this.authIdentifier }
        : { phone_number: this.authIdentifier }),
      ...(request ? { otp_request: true } : {})
    };
  }

  private otpCodeValue(): string {
    return Array.from({ length: 6 }, (_, index) =>
      String(this.otpCodeForm.get(`d${index}`)?.value || '')
    ).join('');
  }

  private startAuthResendTimer(): void {
    this.stopAuthResendTimer();
    this.authResendSeconds = 30;
    this.authResendTimer = setInterval(() => {
      this.authResendSeconds = Math.max(0, this.authResendSeconds - 1);
      if (this.authResendSeconds === 0) {
        this.stopAuthResendTimer();
      }
    }, 1000);
  }

  private stopAuthResendTimer(): void {
    if (this.authResendTimer) {
      clearInterval(this.authResendTimer);
      this.authResendTimer = null;
    }
  }

  private focusOtpDigit(index: number): void {
    document.querySelector<HTMLInputElement>(`[data-otp-index="${index}"]`)?.focus();
  }

  private authApiError(error: any, fallback: string): string {
    return error?.error?.errors?.[0]?.error ||
      error?.error?.data?.message ||
      error?.error?.message ||
      fallback;
  }
  logoutUser(){
    localStorage.removeItem('userEasy');
    this.isLoggedIn=false;
  }

  reloadPage(): void {
    window.location.reload();
  }
  getUserProfile(user:any){
    this.users.getProfile(user).subscribe(
      response => {
          this.loadingStart=false;
          this.resMsg=response;
          const profile = {
            ...user,
            ...(this.resMsg.data || {}),
            token: this.resMsg.data?.token || user.token
          };
          localStorage.setItem('userEasy', JSON.stringify(profile));
      },
      error => {
        localStorage.removeItem('userEasy');
        this.isLoggedIn=false;
        this.sessionService.changeMessage("nouser")
      }
    );
  }

  onActivate(event) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    let scrollToTop = window.setInterval(() => {
        let pos = window.pageYOffset;
        if (pos > 0) {
            window.scrollTo(0, pos - 20); // how far to scroll on each step
        } else {
            window.clearInterval(scrollToTop);
        }
    }, 16);
}

initiateResetPassword= () => {
  document.getElementById("closeLogin").click();
  document.getElementById("openModalReset").click();
}


submitLogin = () => {
  this.loginsubmitted=true;
  this.loadingLogin=true;
 if (this.loginForm.invalid ) {
  this.loginsubmitted=false;
  this.loadingLogin=false;
    return;
 }
let value = this.loginForm.value;
let webformlogin={
  "password": value.password,
  'email':value.email,
}
this.users.login(webformlogin).subscribe(
  response => {
      this.loadingLogin=false;
      this.loginsubmitted=false;
      this.successLogin = true;
      this.resMsg=response;
      if(this.resMsg.data){
        localStorage.setItem('isLoggedInEasy','true');
        localStorage.setItem('userEasy',JSON.stringify(this.resMsg.data));
        this.user=new User().deserialize(JSON.parse(localStorage.getItem('userEasy')))
        this.isLoggedIn=true;
        this.sessionService.changeMessage(this.resMsg.data)
        this.users.changeSuccessMessage(this.resMsg.data)
        sessionStorage.setItem('userEasy',JSON.stringify(this.resMsg.data));
        document.getElementById("closeLogin").click();
        this.router.navigate(['/user-profile']);

        
      }
  },
  error => {
      this.successLogin = false;
      this.loginsubmitted=false;
      this.loadingLogin=false;
      this.is_api_error_login=true;
      this.api_error=new Error().deserialize(error.error.errors[0])
      this.api_error_login=error.error.errors[0].error;

  }
);
}

submitSignUp = () => {
  this.submitted = true;
  this.loadingSignup=true;
  // stop here if form is invalid
  if (this.signupForm.invalid ) {
    this.submitted = false;
    this.loadingSignup=false;
      return;
  }
  let value = this.signupForm.value;
  let webformdata={
    "first_name": value.first_name,
    "last_name": value.last_name,
    "email": value.email,
    "password": value.password,
    "id_number": value.id_number,
    "phone_number": '+254'+ value.phone_number.substring(1)
  }
  this.users.signUp(webformdata).subscribe(
    response => {
      this.loadingSignup=false;
        this.success = true;
        this.resMsg=response;
        this.res= this.resMsg.data.message;
        document.getElementById("closeSignup").click();
        document.getElementById("openSuccessButton").click();
    },
    error => {
        this.success = false;
        this.loadingSignup=false;
        this.user=new User().deserialize(error.error.errors[0])

    }
  );
}

submitResetPassword = () =>{
  this.resetsubmitted=true;
  this.loadingReset=true;
 if (this.resetForm.invalid ) {
  this.resetsubmitted=false;
  this.loadingReset=false;
    return;
 }
let value = this.resetForm.value;
let webformReset={
  "email": value.email
}
this.users.passwordReset(webformReset).subscribe(
  response => {
      this.loadingReset=false;
      this.resetsubmitted=false;
      this.successReset = true;
      this.resMsg=response;
      this.resetSuccessMsg=this.resMsg.data.message;
      this.user_email_reset=value.email;
      document.getElementById("openCodeButton").click();
      document.getElementById("closeReset").click();
  },
  error => {
      this.successReset = false;
      this.resetsubmitted=false;
      this.loadingReset=false;
      this.api_error= new Error().deserialize(error.error.errors);
      this.resetErrMsg=this.api_error.getTheMessage(this.api_error);

  }
);
}

// send reset code to verify
submitCode= () =>{
  this.codeubmitted=true;
  this.loadingCode=true;
 if (this.codeForm.invalid ) {
  this.codeubmitted=false;
  this.loadingCode=false;
    return;
 }
let value = this.codeForm.value;

let webformCode={
  "email": this.user_email_reset,
  "otp": value.code
}

this.users.sendCode(webformCode).subscribe(
  response => {
      this.loadingCode=false;
      this.codeubmitted=false;
      this.successode = true;
      this.resMsg=response;
      this.codeSuccessMsg=this.resMsg.data.message;
      this.passToken=this.resMsg.data.token;
      document.getElementById("closeCode").click();
      document.getElementById("openUpdatePassword").click();
  },
  error => {
      this.successode = false;
      this.codeubmitted=false;
      this.loadingCode=false;
      this.api_error= new Error().deserialize(error.error.errors);
      this.codeSuccessMsg=this.api_error.getTheMessage(this.api_error);
  }
);
}

// send reset code to verify
updatePassword= () =>{
  this.updateSubmitted=true;
  this.loadingPasswordUpdate=true;
 if (this.passwordUpdateForm.invalid ) {
    this.updateSubmitted=false;
    this.loadingPasswordUpdate=false;
    return;
 }
let value = this.passwordUpdateForm.value;

let webformCode={
  "email": this.user_email_reset,
  "new_password": value.password,
  "token": this.passToken
}
this.users.sendUpdatePassword(webformCode).subscribe(
  response => {
      this.loadingUpdatePassword=false;
      this.updateSubmitted=false;
      this.successPasswordUpdate = true;
      this.resMsg=response;
      this.updatePassSuccessMsg=this.resMsg.data.message;
    
      setTimeout(function () {
        document.getElementById("closePasswordUpdate").click();
        document.getElementById("openResetSuccessButton").click();
      },2000)


  },
  error => {
      this.successPasswordUpdate = false;
      this.updateSubmitted=false;
      this.loadingPasswordUpdate=false;
      this.api_error= new Error().deserialize(error.error.errors);
      this.updatePassSuccessMsg=this.api_error.getTheMessage(this.api_error);
  }
);
}

}
